"use strict";
/*
 * Created on 09 03 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var DomainObject_1 = require("../../core/model/DomainObject");

var ProgressMonitorKind_1 = require("../../core/model/ProgressMonitorKind"); //tslint:disable:max-classes-per-file

/**
 * <p>Distinguishes monitor related to upload of CSV file related to {@link SiteReleaseUpload}.</p>
 *
 * @author JMe
 */


var SiteReleaseUploadMonitor =
/*#__PURE__*/
function (_ProgressMonitorKind_) {
  _inherits(SiteReleaseUploadMonitor, _ProgressMonitorKind_);

  function SiteReleaseUploadMonitor() {
    _classCallCheck(this, SiteReleaseUploadMonitor);

    return _possibleConstructorReturn(this, _getPrototypeOf(SiteReleaseUploadMonitor).apply(this, arguments));
  }

  _createClass(SiteReleaseUploadMonitor, [{
    key: "validate",

    /**
     * @inheritDoc
     */
    value: function validate() {
      return true;
    }
  }]);

  return SiteReleaseUploadMonitor;
}(ProgressMonitorKind_1.ProgressMonitorKind);

exports.SiteReleaseUploadMonitor = SiteReleaseUploadMonitor;
SiteReleaseUploadMonitor.TAG = ProgressMonitorKind_1.ProgressMonitorKind.register(SiteReleaseUploadMonitor);
/**
 * <p>Enumerates main phases of uploading source data related to creation of a release of regular prices to sites. A phase should be taken
 * into account while monitoring the uploading progress. Each phase should have different weight within the process.</p>
 *
 * @author JMe
 */

var SiteReleaseUploadPhaseEnum;

(function (SiteReleaseUploadPhaseEnum) {
  /**
   * Checks, that header of input file is correct.
   * <br/>
   * Suggested weight: low.
   */
  SiteReleaseUploadPhaseEnum["DataStructureCheck"] = "DATA_STRUCTURE_CHECK";
  /**
   * Checks, that all rows contains required attributes. Checked while parsing CSV to {@link SiteReleaseUploadedItem}.
   * <br/>
   * Suggested weight: low.
   */

  SiteReleaseUploadPhaseEnum["DataRequiredAttributesCheck"] = "DATA_REQUIRED_ATTRIBUTES_CHECK";
  /**
   * Transforms CSV rows to {@link SiteReleaseUploadedItem}.
   * <br/>
   * Suggested weight: medium.
   */

  SiteReleaseUploadPhaseEnum["DataRawRowsImport"] = "DATA_RAW_ROWS_IMPORT";
  /**
   * Validates transformed {@link SiteReleaseUploadedItem}, last phase during which uploading process still may be aborted.
   * <br/>
   * Suggested weight: high.
   */

  SiteReleaseUploadPhaseEnum["DataRowsValidation"] = "DATA_ROWS_VALIDATION";
  /**
   * Transforms uploaded {@link SiteReleaseUploadedItem} to {@link SiteReleaseItem} and creates {@link SiteRelease}.
   * <br/>
   * Suggested weight: high.
   */

  SiteReleaseUploadPhaseEnum["DataRawRowsTransformation"] = "DATA_ROWS_TRANSFORMATION";
  /**
   * Final step, {@link SiteRelease} is associated with {@link SiteReleaseUpload} and progress is finished.
   * <br/>
   * Suggested weight: medium.
   */

  SiteReleaseUploadPhaseEnum["DataReleaseDataCreated"] = "DATA_RELEASE_DATA_CREATED";
})(SiteReleaseUploadPhaseEnum = exports.SiteReleaseUploadPhaseEnum || (exports.SiteReleaseUploadPhaseEnum = {}));
/**
 * @const
 *
 * <p>Default implementation of {@link SiteReleaseUploadPhaseWeights}.</p>
 *
 * @author JMe
 */


exports.SITE_RELEASE_UPLOAD_PHASE_WEIGHTS = immutable_1.Map([[SiteReleaseUploadPhaseEnum.DataStructureCheck, 1], [SiteReleaseUploadPhaseEnum.DataRequiredAttributesCheck, 1], [SiteReleaseUploadPhaseEnum.DataRawRowsImport, 10], [SiteReleaseUploadPhaseEnum.DataRowsValidation, 20], [SiteReleaseUploadPhaseEnum.DataRawRowsTransformation, 40], [SiteReleaseUploadPhaseEnum.DataReleaseDataCreated, 10]]);
/**
 * <p>Upload summary of data related to {@link SiteRelease}.</p>
 *
 * <p><b>If the uploaded file does not fulfill basic conditions such as file data format, data structure, etc., there wont'be created
 * any associated {@link SiteReleaseUploadedItem} related to the upload.</b></p>
 *
 * @author Jaroslav Sevcik
 * @author JMe
 */

var SiteReleaseUpload =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SiteReleaseUpload, _DomainObject_1$Domai);

  /**
   * @param id
   * @param name A name of the upload, this will represent the name of created {@link SiteRelease} if there won't be any validation error.
   * @param description A description of a release being created.
   * @param issued The moment the upload process was issued.
   * @param progressId The identification of upload processing (validations and such). Client should query the progress state until the
   *        process is in the final state.
   * @param releaseId Corresponds to {@link SiteRelease.id}. Filled in case there are no crucial errors within an uploaded file. If,
   *        filled, client should redirect user to release detail page.
   * @param validation Validation result of upload. You should use this result to recognize if the validation contains some errors or not.
   *        May aggregate summary info in case of errors within some {@link SiteReleaseUploadedItem items}.
   */
  function SiteReleaseUpload(id, name, description, issued, progressId, releaseId, validation) {
    var _this;

    _classCallCheck(this, SiteReleaseUpload);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SiteReleaseUpload).call(this));
    _this.id = id;
    _this.name = name;
    _this.description = description;
    _this.issued = issued;
    _this.progressId = progressId;
    _this.releaseId = releaseId;
    _this.validation = validation;
    return _this;
  }

  return SiteReleaseUpload;
}(DomainObject_1.DomainObject);

exports.SiteReleaseUpload = SiteReleaseUpload;